export default __webpack_public_path__ + "static/media/mapLine.bb44eab3.png";